
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CustomerDetailsFieldset from '@/components/fieldsets/CustomerDetailsFieldset.vue';
import ChooseAddressFieldset from '@/components/fieldsets/ChooseAddressFieldset.vue';
import LegsFieldset from '@/components/fieldsets/LegsFieldset.vue';
import JobbookingCreateSubmitBtn from '@/components/btns/JobbookingCreateSubmitBtn.vue';
import { JobDetailedData } from '@/models/jobDetailed';
// import { fetchPostJobClone } from '@/helpers/fetchers';
import * as routeNames from '@/router/routeNames';
import { cloneDetailedJob, uncloneDetailedJob, getIsDatesError } from '@/helpers/booking';

@Component({
  components: {
    CustomerDetailsFieldset,
    ChooseAddressFieldset,
    LegsFieldset,
    JobbookingCreateSubmitBtn,
  },
})
export default class JobbookingCreateForm extends Vue {
  @Prop(Boolean) public isInitialLoading?: boolean;
  @Prop(Object) public initialDetailedJob?: JobDetailedData;

  public isSubmitting = false;
  public detailedJob?: JobDetailedData | null = null;
  public isValid = true;
  public isDatesError = false;

  get isLoading() {
    return this.isInitialLoading || this.isSubmitting;
  }

  @Watch('initialDetailedJob', { immediate: true })
  private watchInitialDetailedJob(initialDetailedJob) {
    if (this.detailedJob) {
      return;
    }
    if (this.initialDetailedJob) {
      this.detailedJob = cloneDetailedJob(initialDetailedJob);
    }
  }

  @Watch('detailedJob.stops', { deep: true })
  private isErrorWatcher() {
    if (!this.detailedJob) {
      return;
    }
    this.isDatesError = getIsDatesError(this.detailedJob.stops);
  }

  public handleSubmit(event: SubmitEvent | PointerEvent) {
    event.preventDefault();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    if (!this.detailedJob) {
      return;
    }
    if (this.isDatesError) {
      return;
    }
    this.isSubmitting = true;
    // fetchPostJobClone(uncloneDetailedJob(this.detailedJob))
    //   .then(({ jobId, jobDate }) => {
    //     return this.$router.push({
    //       name: routeNames.DETAILED_QUERY_JOB,
    //       query: { job_id: String(jobId), job_date: jobDate },
    //     });
    //   })
    //   .finally(() => {
    //     this.isSubmitting = false;
    //   });
  }
}
